import React, { useState } from "react";
import logo from "../assets/logo/Logo.png";
import google from "../assets/logo/google.png";
import facebook from "../assets/logo/facebook.png";
import apple from "../assets/logo/apple.png";
import Carousel from "../components/carousel/logincarousel";
import loginbanner from "../assets/images/login-banner.png";
import loginbannertwo from "../assets/images/login-banner-2.png";
import loginbannerthree from "../assets/images/login-banner-3.png";
import loginbannerfour from "../assets/images/login-banner-4.png";
import loginbannersm from "../assets/images/login-banner-sm.png";
import bannerlayout from "../assets/images/banner-layout.png";
import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/react";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function VerifyCode() {
  const [code, setCode] = useState("");
  const [error, setError] = useState(null);
  const navigate = useNavigate(); // Hook for navigation
  const API_URL = "https://pipaan.com360degree.com/api/auth";

  // ✅ Handle Resend OTP
  const handleResendOTP = async (e) => {
    e.preventDefault();
    setError(null);
    const storedEmail = sessionStorage.getItem("userEmail");

    if (!storedEmail) {
      toast.error("No email found. Please sign up again.");
      return;
    }

    try {
      const response = await fetch(`${API_URL}/forget-password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: storedEmail }),
      });

      const data = await response.json();
      console.log("Resend OTP Response:", data);

      if (response.ok && data.success) {
        if (data.result?.data) {
          sessionStorage.setItem("resetToken", data.result.data);
          console.log("New Reset Token stored:", data.result.data);
        }
        toast.success("A new OTP has been sent to your email.");
      } else {
        setError(data.message || "Failed to resend OTP. Please try again.");
      }
    } catch (error) {
      console.error("Error:", error);
      setError("Something went wrong. Please try again.");
    }
  };

  // ✅ Handle OTP Submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);

    const token = sessionStorage.getItem("resetToken");
    if (!token) {
      setError("Session expired. Please request a new OTP.");
      return;
    }

    try {
      const response = await fetch(`${API_URL}/validate-otp`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ token, otp: code }),
      });

      const data = await response.json();
      console.log("API Response:", data);

      if (response.ok && data.success) {
        sessionStorage.setItem("otp", data.result?.otp || "");
        toast.success("✅ OTP Verified! Redirecting...");
        navigate("/resetpassword");
      } else {
        // ✅ Show the exact error message from API response
        setError(data.message || "Invalid OTP. Please try again.");
      }
    } catch (error) {
      console.error("Error:", error);
      setError("Something went wrong. Please try again.");
    }
  };

  return (
    <div className="login">
      <div className="container min-h-screen flex">
        {/* Left Side Image */}
        <div className="hidden lg:block lg:w-1/2">
          <div className="carousel-size pb-3 pt-3">
            <Carousel slides={[loginbanner, loginbannertwo, loginbannerthree, loginbannerfour]} />
            <img src={bannerlayout} alt="Overlay" className="layout" />
          </div>
          <div className="copy-rights py-6 text-center text-sm text-[#095228]">
            © 2025 Pipaan. All Rights Reserved
          </div>
        </div>

        {/* Right Side Form */}
        <div className="w-full lg:w-1/2 login-content flex flex-col">
          <div className="login-form">
            {/* Header */}
            <div className="reset-pass flex flex-col items-center justify-center px-6">
              <div className="logo">
                <img src={logo} alt="Pipaan Logo" width={150} height={50} />
              </div>

              <div className="w-full max-w-md">
                <h1 className="login-title text-2xl font-semibold text-left mb-2">Verify Code</h1>
                <p className="text-left text-[#313131] text-sm mb-8">
                  An authentication code has been sent to your email.
                </p>

                {/* ✅ Verification Form */}
                <form onSubmit={handleSubmit} className="space-y-4 mb-10">
                  <div className="w-full relative mb-5 reset-pass-content">
                    <input
                      type="text"
                      placeholder="Enter Verification Code"
                      value={code}
                      onChange={(e) => setCode(e.target.value)}
                      className="w-full h-12 px-4 pr-12 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                      required
                    />
                  </div>

                  {/* ✅ Display API Error Message */}
                  {error && <p className="text-red-500 text-sm">{error}</p>}

                  <button type="submit" className="w-full bg-[#1B2537] hover:bg-[#1B2537]/90 text-[#FFFFFF] py-3 rounded-xl font-medium">
                    Verify
                  </button>
                </form>

                {/* Resend OTP */}
                <p className="text-sm text-[#313131] text-center">
                  Didn’t receive a code?{" "}
                  <button className="text-[#006838] font-medium hover:underline" onClick={handleResendOTP}>
                    Resend
                  </button>
                </p>

                {/* Social Login */}
                <div className="relative my-6">
                  <div className="absolute inset-0 flex items-center">
                    <div className="w-full border-t border-gray-200"></div>
                  </div>
                  <div className="relative flex justify-center text-sm">
                    <span className="bg-white px-2 text-gray-500">Login With</span>
                  </div>
                </div>

                <div className="grid grid-cols-3 gap-4 mb-10">
                  <button className="w-full rounded-lg">
                    <img src={google} alt="Google" className="mx-auto" />
                  </button>
                  <button className="w-full rounded-lg">
                    <img src={facebook} alt="Facebook" className="mx-auto" />
                  </button>
                  <button className="w-full rounded-lg">
                    <img src={apple} alt="Apple" className="mx-auto" />
                  </button>
                </div>

                {/* Signup Link */}
                <p className="text-center text-sm text-[#313957] mt-4">
                  Don't have an account?{" "}
                  <Link to="/signup" className="text-[#006838] font-medium hover:underline">
                    Create New Account
                  </Link>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
